<!--GET RESOLUTION VIEW-->
<div *ngIf="!started && ready && gettingResolution && gettingResolutionStarted"
    style="text-align: -webkit-center;text-align: -moz-center; position: absolute; height: 100vh;">
    <app-get-resolution [fullScreen]="fullScreen" [setFullScreen]="setFullScreen" [setResolution]="setResolution"
        [endGettingResolution]="endGettingResolution"></app-get-resolution>
</div>

<!--TEST VIEW-->
<!--DEMO-->
<div *ngIf="started && ready && testView && demo"
    style="text-align: -webkit-center;text-align: -moz-center; position: absolute; height: 100vh;">
    <app-practice [fullScreen]="fullScreen" [setFullScreen]="setFullScreen" [rX]="resX" [rY]="resY" [endDemo]="endDemo">
    </app-practice>
</div>
<!--ACTUAL TEST-->
<div *ngIf="started && ready && testView && !demo"
    style="text-align: -webkit-center;text-align: -moz-center; position: absolute; height: 100vh;">
    <app-actual-test [fullScreen]="fullScreen" [setFullScreen]="setFullScreen" [rX]="resX" [rY]="resY"
        [setAnswers]="setAnswers" [save]="save">

    </app-actual-test>
</div>

<div *ngIf="!fullScreen" style="text-align: -webkit-center;text-align: -moz-center;  margin-top: 3rem;">

    <div class="card" style="margin: 16px; text-align: center; width: 70%; min-width: 30rem;">

        <!--ALREADY DONE TEST-->
        <div *ngIf="!done && charged2">
            <p style="font-size: x-large; font-weight: 500;"> {{'ALREADY_DONE_TEST' | translate}} </p>
        </div>

        <!--SPINNER WHILE LOADING PAGE-->
        <div *ngIf="!done && !charged2" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
            <mat-spinner diameter="30"></mat-spinner>
        </div>

        <div *ngIf="done">

            <!--TITLE-->
            <h1 *ngIf='!started || !demo && !finished' style="font-size: 3em;">{{'MP_T1' | translate}}</h1>
            <h1 *ngIf='started && demo && !finished' style="font-size: 3em;">{{'MP_T2' | translate}}
            </h1>

            <!--GET RESOLUTION INSTRUCTIONS-->
            <div *ngIf="!started && ready && gettingResolution && !gettingResolutionStarted"
                style="text-align: -webkit-center;text-align: -moz-center;">

                <p>
                    {{'MP_P1' | translate}}
                </p>
                <p>
                    {{'MP_P2' | translate}}
                </p>
                <p>
                    {{'MP_P3' | translate}}
                </p>
                <button mat-raised-button class="button" (click)="startResolution()">{{'START' | translate}}</button>
            </div>



            <div *ngIf="!started && ready && !gettingResolution && demo"
                style="text-align: -webkit-center;text-align: -moz-center;">

                <p>
                    {{'MP_P4' | translate}}
                </p>
                <p>
                    {{'MP_P6' | translate}}
                </p>
                <p>
                    {{'MP_P7' | translate}}
                </p>
                <p>{{'MP_P8' | translate}}</p>
                <div style="margin-top: 5px; margin-bottom: 5px;">
                    <app-sketch-demo></app-sketch-demo>
                </div>

                <button mat-raised-button class="button" (click)="start()">{{'MP_B1' | translate}}</button>


            </div>

            
            <!--PRACTICE FINISHED-->
            <div *ngIf="!started && ready && !gettingResolution && !demo">
                
                <p>
                    {{'MP_P9' | translate}}
                </p>

                <div style="display:flex; justify-content:center ;">
                    <button *ngIf="!started" mat-raised-button class="button" (click)="redoDemo()"
                      style="margin-right: 3px;">{{'FB_P4' | translate}}</button>
                    <button *ngIf="!started" mat-raised-button class="button" (click)="startTest()">{{'START' | translate}}</button>
                </div>
            </div>

            <!--TEST VIEW-->
            <div *ngIf="started && ready && !testView && !finished && !saving && demo"
                style="text-align: -webkit-center;text-align: -moz-center;">

                <p>
                    {{'MP_P10' | translate}}
                </p>
                
                <p>
                    {{'MP_P8' | translate}}
                </p>

                <p>
                    {{'MP_P11' | translate}}
                </p>
                <button mat-raised-button class="button" (click)="startTest()">{{'MP_B1' | translate}}</button>

            </div>

            <!--FINISHED TEST-->
            <div *ngIf="started && ready && !testView && finished && !saving"
                style="text-align: -webkit-center;text-align: -moz-center;">
                <p style="font-size: x-large; font-weight: 500;"> {{'SUCCESS_TEST' | translate}} </p>
            </div>
        </div>
    </div>
</div>